import classNames from 'classnames';
import type React from 'react';

export interface ContainerProps {
  children: React.ReactNode;
  partialHeight?: boolean;
}

export const Container = ({ children, partialHeight }: ContainerProps) => {
  return (
    <div
      className={classNames('w-full flex justify-center items-stretch', {
        'h-full': !partialHeight,
      })}
    >
      <div className="h-full w-ds-page">{children}</div>
    </div>
  );
};
